import {
    capitalCase,
    usePintMaster,
    useRecentInjector,
    useServerPagination,
    useToggle,
    vtrUrl,
  } from '@lib/common';
  import { EntityType } from '@lib/deals';
  import { DataGrid, DataGridProps} from '@material-ui/data-grid';
  import React, { useState, useRef, useEffect, useCallback, useMemo} from 'react';
  import { map } from 'rxjs/operators';
  import { contentToColumns } from './columns';
  import * as pintService from '@api/pint';
  import * as companyService from '@api/company';
  import * as personService from '@api/person';
  import clsx from 'clsx';
  import {
    Card,
    CardContent,
    CardHeader,
    Chip,
    Link,
    Collapse,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    Typography,
    Avatar,
    makeStyles,
    createStyles,
    Tooltip,
    TextField,
  } from '@material-ui/core';
  import { grey, red } from '@material-ui/core/colors';
  import SearchBox from '@components/search-box';
  import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
  import LaunchIcon from '@material-ui/icons/Launch';
  import DeleteIcon from '@material-ui/icons/Delete';
  import NotInterestedRoundedIcon from '@material-ui/icons/NotInterestedRounded';
  import { ColoredChip } from '@components/colored-elements';
  import BackspaceIcon from '@material-ui/icons/Backspace';
  import { EntityIcon } from '@components/entity-type-icon';
  import { AiOutlineInfoCircle, BsPencilSquare } from '@icon/react-icons';
  import InputBase from '@material-ui/core/InputBase';
  import { useCompanyLoader } from 'services/company-dataloader.service';
  import { Skeleton } from '@material-ui/lab';
  import CategoryIcon from '@material-ui/icons/Category';
  import LanguageIcon from '@material-ui/icons/Language';
  import { usePersonLoader } from 'services/person-dataloader.service';
  import styled from 'styled-components';
  import { thumbStack } from '@lib/common/css';
  import AddToQueueIcon from '@material-ui/icons/AddToQueue';
  import { companyRequestApi as companyRequestService } from '@api/company-request';
  import { useSnackbar } from 'notistack';
  import { CreateEntityRequest } from './entity-request';
  import Badge from '@material-ui/core/Badge';
  import { withStyles } from '@material-ui/core/styles';
  import { of } from 'rxjs';
  import CheckCircleIcon from '@material-ui/icons/CheckCircle';
  import CancelIcon from '@material-ui/icons/Cancel';
  import { Link as Link1 } from 'react-router-dom';
  import { DELI_ENV_BASE_URL, http_v3 } from '@api/client';
  import { Autocomplete } from '@material-ui/lab';
  import CircularProgress from '@material-ui/core/CircularProgress';
  import { debounce } from 'lodash';
import { computeReputationBadge } from '@pages/company-reputation-score/Tabs/CompanyReputationTab/BadgeConfig';
import { getBadgeColor } from '@components/entity-search/columns';
import { MarketsResponsibleField } from './markets-responsible-field';
  interface EntitySearchModel {
    vtr_id: string;
    type: string;
    name: string;
    relation_type: string;
    meta?: any;
    //Below are for clearing already existing data in partial entity
    imdb_id?: string;
    deal_id?: number | string;
    confidence?: number;
    deal_content_genre?: string;
    language?: string;
    country_of_origin?: string;
    deal_content_type?: string;
    book_name?: string;
    working_title?: string;
    deal_season?: string;
    original_title?: string;
    publish?: number;
    hqcountry?: string;
    markets_responsible?: string;
  }
  
  const useEntityStyle = makeStyles(theme =>
    createStyles({
      expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shortest,
        }),
      },
      expandOpen: {
        transform: 'rotate(180deg)',
      },
      disabledCard: {
        background: grey[100],
      },
      hoverEditEntity: {
        '&:hover $editEntity': {
          opacity: 1,
        },
      },
      editEntity: {
        opacity: 0,
      },
      inputBaseStyle: {
        fontSize: '1.5rem',
      },
    })
  );
  
  export function EntitySearchMultiPartyC2P({
    label,
    hideTypeSelect = false,
    clearable = false,
    defaultValue = { name: '', type: EntityType.company, vtr_id: '', relation_type: 'buyer' },
    onChange = null,
    changeBuyer = null,
    titleEditable = false,
    fixedType = '',
    indexOfEntities,
    removeDealEntities,
    isDealEntityRemovable = false,
    isDealEntityRequestCreatable = true,
    dealData = null,
    disabled = false,
    defaultSearchIn = 'name',
    stopInitialCall = false,
    companyPublishable = false,
  }) {
    const didMount = useRef(false);
    const [stopInitialCallRef, setStopInitialCallRef] = useState(stopInitialCall);
    const [expand, toggleExpanded] = useToggle(false);
    const [searchText, setSearchText] = useState(
      defaultSearchIn == 'vtr_id' ? defaultValue.vtr_id : defaultValue.name
    );
    const isSeller = label === 'Seller';
    const [type, setType] = useState(defaultValue.type);
    const [entityNameEditable, toggleEntityNameEditable] = useToggle(false);
    const classes = useEntityStyle();
    const resolvedType = fixedType || type || (EntityType.company as string);
  
    const [searchIn, setSearchIn] = useState(defaultSearchIn);
  
    const showSearchIn = resolvedType === EntityType.company || resolvedType === EntityType.person;
  
    const [searchTrigger, setSearchTrigger] = useState(0);
    const [tableReload, setTableReload] = useState(false);
  
    // Entity Values
    const [entity, setEntityValue] = useState<EntitySearchModel>(defaultValue);
    const resolvedTypeValue = fixedType || entity.type || EntityType.company;
    // Form Change.
    const setPartialEntity = useRecentInjector(
      [onChange, setEntityValue, entity] as const,
      ([onChange, setEntityValue, entity], value: Partial<EntitySearchModel>) => {
        const newValue = { ...entity, ...value };
        setEntityValue(newValue);
        onChange && onChange(newValue);
        changeBuyer && changeBuyer(newValue);
      }
      
    );
    const entityNameEl = useRef(null);
  
    const refreshTable = ()=>{
      setSearchText(searchText);
      setSearchTrigger(t => t + 1);
      resetPagination();
      setTableReload(true)
      toggleExpanded();
    }
   const { loading: loading_badges, master: reputation } = usePintMaster('reputation_badge');
  
    const badges = useMemo(
        () => (Array.isArray(reputation) ? reputation : []),
        [reputation]
      );
  
    const { resetPagination, ...paginationProps } = useServerPagination(
      ({ page, pageSize }) => {
        if (!didMount.current && stopInitialCall) {
          didMount.current = true;
          return of({ data: [] });
        }
        setStopInitialCallRef(prev => false);
        if (resolvedType === EntityType.company) {
                    // 🚨 Stop API call until badges are loaded
            if (loading_badges || badges.length === 0) {
              return of({ data: [], count: 0 });
            }
          return companyService
            .filter_add_entity({
              filters: [
                searchIn === 'name'
                  ? { 
                      id: 'vtr_company_name',
                      value: {
                        $contains: searchText,
                      },
                    }
                  : {
                      id: 'vtr_id',
                      value: {
                        $eq: searchText,
                      },
                    },
              ],
              page,
              pageSize,
            })
            .pipe(
              map(res => ({
                count: res.data.count,
                data: res.data.data.map(d => ({
                  ...d,
                  setPartialEntity,
                  id: d.vtr_id,
                  name: d.vtr_company_name,
                  projects_count: d.deal_content_count.content_count,
                  reputation: d.deal_content_count.reputation,
                  reputation_badge: computeReputationBadge(d.deal_content_count.reputation ?? 0,badges),
                  connections: d.deal_content_count.connections,
                  deals: d.deal_content_count.deal_count,
                  country_names: d.hqcountry,
                  company_type: (d.company_types || []).map(t => t.name).join(', '),
                })),
              }))
            );
        }         else if (resolvedType === EntityType.person) {
          return personService
            .personSearch({
              searchKey: (searchIn as any) || 'name',
              query: searchText,
              page,
              pageSize,
            })
            .pipe(
              map(res => {
                return {
                  ...res.data,
                  count: res.data.count,
                  data: res.data.data.map(d => ({ ...d, id: d.vtr_id, setPartialEntity, refreshTable, isSeller})),
                };
              })
            );
        } 
  
        return pintService
          .search(resolvedType.toLowerCase() as any, {
            query: searchText,
            start: pageSize * (page - 1),
            limit: pageSize,
            ...(searchText && resolvedType === EntityType.content
              ? { sort: 'asc', sort_key: 'title' }
              : {}),
          })
          .pipe(
            // Normalize to concur with server pagination params
            map(res => ({
              data: (res.data[Object.keys(res.data)[0]] as Array<any>).map(d => ({
                ...d,
                id: d.vtr_id,
                setPartialEntity,
              })),
              count: typeof res._pages === 'string' ? 0 : res._pages.total,
            }))
          );
      },
      { defPageSize: 30 },
      [resolvedType, searchTrigger,loading_badges]
    );
  
    useEffect(()=>{
      if(!paginationProps?.loading && tableReload){
        setSearchTrigger(t => t + 1);
        setTableReload(false)
        toggleExpanded();
      }
    },[tableReload])
  
    const noId = !entity.vtr_id;
    const noName = !entity.name;
    const noValue = noId && noName;
    const showEditIcon = noId && titleEditable;
    const isTypeEditable = noId && !fixedType;
    const onTypeClick = () => {
      // Toggle Type on Click
      if (isTypeEditable) {
        setPartialEntity({
          type: resolvedTypeValue === EntityType.company ? EntityType.person : EntityType.company,
        });
      }
    };
  
    const clearContent = () => {
      setPartialEntity({
        vtr_id: '',
        name: '',
        meta: null,
        type: null,
        deal_content_genre: null,
        language: null,
        country_of_origin: null,
        imdb_id: null,
        deal_content_type: null,
        working_title: null,
        book_name: null,
        deal_season: null,
        original_title: null,
      });
    };
  
    const updateEntityName = value => {
      setPartialEntity({ name: value, type: resolvedTypeValue, meta: null });
    };
    const updateType = evt => {
      const value = evt.target.value as EntityType;
      setType(() => value);
      // Side effects
      resetPagination();
    };
  
    //resize the inputbase to width equal the length of the value
    const reSizeInputBase = () => {
      let length = entityNameEl.current.firstChild.value.length;
      entityNameEl.current.style.width = `${length ? length * 1.2 : 16}ch`;
    };
  
    //After fresh load of input base resize the width equal to the length of the value
    //Use timeout since the inputbase is created asynchronosuly
    const freshLoadInputBaseToUpdateWidth = () => {
      setTimeout(() => reSizeInputBase(), 0);
    };
  
    const [createRequestOpen, , showCreateRequestDialog, hideCreateRequestDialog] = useToggle(false);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const onCreateRequestFinish = useCallback(requestData => {
      const infoNotification = enqueueSnackbar('Please wait Creating Company Request', {
        variant: 'info',
      });
      return companyRequestService.create(requestData).subscribe({
        next: () => {
          enqueueSnackbar('Company Request Created Successfully!', { variant: 'success' });
          setbadgeContentForCompanyState(prevVal => prevVal + 1);
          hideCreateRequestDialog();
        },
        error: err => {
          enqueueSnackbar(`Error Creating company request (${err?.response?.data?.error})`, {
            variant: 'error',
          });
        },
        complete: () => closeSnackbar(infoNotification),
      });
    }, []);
  
    const [badgeContentForCompanyState, setbadgeContentForCompanyState] = useState(0);
    useEffect(
      () =>
        setbadgeContentForCompanyState(
          dealData && dealData.company_requests
            ? dealData.company_requests.filter(eachRequest => eachRequest.company_name == entity.name)
                .length
            : 0
        ),
      [dealData && dealData.company_requests ? dealData.company_requests : null]
    );
  
    return (
      <Card className={clsx(noValue && !expand && classes.disabledCard)} elevation={2}>
        <CardHeader
          subheader={label}
          avatar={
            <Avatar
              onClick={onTypeClick}
              style={{
                cursor: isTypeEditable && 'pointer',
              }}>
              <EntityIcon disabled={noValue} type={resolvedTypeValue} />
            </Avatar>
          }
          title={
            <>
              {entityNameEditable ? (
                <>
                  <InputBase
                    autoFocus
                    placeholder="Enter an entity"
                    defaultValue={entity.name}
                    onBlur={toggleEntityNameEditable}
                    className={classes.inputBaseStyle}
                    inputProps={{ 'aria-label': 'Edit entity name' }}
                    onChange={event => {
                      updateEntityName(event.target.value);
                      reSizeInputBase();
                    }}
                    ref={entityNameEl}
                    onFocus={freshLoadInputBaseToUpdateWidth}
                  />
                </>
              ) : (
                <Typography
                  variant="h5"
                  color={noName ? 'textSecondary' : 'inherit'}
                  display="inline"
                  style={{
                    marginRight: showEditIcon ? 0 : 10,
                    lineHeight: 1.334,
                    fontSize: '1.5rem',
                  }}
                  className={classes.hoverEditEntity}>
                  {entity.name || <span className={classes.inputBaseStyle}>Select an entity</span>}
                        {(resolvedTypeValue == EntityType.company || resolvedTypeValue == EntityType.content) ?
                        <Tooltip title="Edit">
                          <span>
                            <BsPencilSquare
                            
                              onClick={toggleEntityNameEditable}
                              className={classes.editEntity}
                              style={{ fontSize: '1rem', marginLeft: '2px' }}
                              color="primary"
                              fontSize="small"
                            />
                          </span>
                        </Tooltip> : '  '}
                </Typography>
              )}
  
              <Typography
                style={{
                  marginRight: 15,
                  cursor: isTypeEditable && 'pointer',
                  userSelect: isTypeEditable ? 'none' : 'auto',
                }}
                color="textSecondary"
                variant="body2"
                onClick={onTypeClick}
                display="inline">
                {capitalCase(resolvedTypeValue)}
              </Typography>
              {entity.vtr_id && entity.type ? (
                <IdentifiedEntityChips entity={entity} setEntityValue={setPartialEntity} type={fixedType} isSeller={isSeller} badges={badges}/>
              ) : (
                <ColoredChip
                  colored={noValue ? grey[600] : red[700]}
                  coloredHover={noValue ? grey[600] : red[900]}
                  size="small"
                  icon={noValue ? <AiOutlineInfoCircle /> : <NotInterestedRoundedIcon />}
                  label={noValue ? 'Empty' : 'Not Identified'}
                />
              )}
            </>
          }
          action={
            <React.Fragment>
              {clearable && !noValue && (
                <Tooltip title="Clear">
                  <IconButton aria-label="remove content" onClick={clearContent} disabled={disabled}>
                    <BackspaceIcon />
                  </IconButton>
                </Tooltip>
              )}
              {isDealEntityRemovable && (
                <Tooltip title="delete entity">
                  <IconButton onClick={() => removeDealEntities(indexOfEntities)} disabled={disabled}>
                    <DeleteIcon style={{ fontSize: '1.5rem' }} />
                  </IconButton>
                </Tooltip>
              )}
              {isDealEntityRequestCreatable &&
                noId &&
                !noName &&
                resolvedTypeValue == EntityType.company && (
                  <>
                    <Tooltip title="Create Company Request">
                      <StyledBadge
                        badgeContent={badgeContentForCompanyState}
                        color="error">
                        <IconButton onClick={showCreateRequestDialog} disabled={disabled}>
                          <AddToQueueIcon style={{ fontSize: '1.5rem' }} />
                        </IconButton>
                      </StyledBadge>
                    </Tooltip>
                    {createRequestOpen && (
                      <CreateEntityRequest
                        dealData={dealData}
                        entityData={entity.name}
                        open={createRequestOpen}
                        onClose={hideCreateRequestDialog}
                        onOk={onCreateRequestFinish}
                        onCancel={hideCreateRequestDialog}
                      />
                    )}
                  </>
                )}
              {companyPublishable && (
                <>
                  {entity.publish == -1 ? (
                    <Tooltip title="UnPublished">
                      <IconButton
                        onClick={() => setPartialEntity({ publish: 1 })}
                        style={{ color: 'red' }}>
                        <CancelIcon style={{ fontSize: '1.5rem' }} />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    <Tooltip title="Published">
                      <IconButton
                        onClick={() => setPartialEntity({ publish: -1 })}
                        style={{ color: 'green' }}>
                        <CheckCircleIcon style={{ fontSize: '1.5rem' }} />
                      </IconButton>
                    </Tooltip>
                  )}
                </>
              )}
              <IconButton
                className={clsx(classes.expand, {
                  [classes.expandOpen]: expand,
                })}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  toggleExpanded();
                }}
                aria-expanded={expand}
                aria-label="show more"
                disabled={disabled}>
                <ExpandMoreIcon />
              </IconButton>
            </React.Fragment>
          }
        />
        <Collapse in={expand} mountOnEnter unmountOnExit>
          <CardContent>
            <Grid container justify="space-between" spacing={2}>
              {!hideTypeSelect && (
                <Grid item>
                  <FormControl style={{ minWidth: 100 }}>
                    <InputLabel id="entity-select-label">Entity Type</InputLabel>
                    <Select
                      labelId="entity-select-label"
                      id="entity-select"
                      value={resolvedType}
                      onChange={updateType}>
                      <MenuItem value={EntityType.company}>Company</MenuItem>
                      <MenuItem value={EntityType.person}>Person</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              )}
              {showSearchIn && (
                <Grid item>
                  <TextField
                    value={searchIn}
                    onChange={evt => setSearchIn(evt.target.value as string)}
                    select
                    SelectProps={{ native: true }}
                    label="Search By">
                    <option value="name">Name</option>
                    <option value="vtr_id">Vitrina Id</option>
                    {fixedType === EntityType.person && 
                    <><option value="hubspot_id">Hubspot Id</option>
                    <option value="imdb_id">IMDB Id</option>
                    <option value="tmdb_id">TMDB Id</option></>}
                  </TextField>
                </Grid>
              )}
              <Grid item xs>
                <SearchBox
                  onSearch={text => {
                    setSearchText(text);
                    setSearchTrigger(t => t + 1);
                    resetPagination();
                  }}
                  defautlValue={searchText}
                  label={`Search`}
                />
              </Grid>
            </Grid>
            <br />
            {searchText && (
              <Typography variant="caption" color="textSecondary">
                Showing Results for <strong>"{searchText}"</strong>
              </Typography>
            )}
            <br />
            <TableContainer>
              <div style={{ width: '100%' }}>
                <EntitySearchResult
                  {...paginationProps}
                  density="compact"
                  rowsPerPageOptions={null}
                  disableColumnFilter
                  disableColumnMenu
                  disableColumnReorder
                  disableColumnResize
                  disableColumnSelector
                  disableSelectionOnClick
                  disableDensitySelector
                  disableMultipleColumnsFiltering
                  disableMultipleSelection
                  disableMultipleColumnsSorting
                  disableExtendRowFullWidth
                  // rowHeight={100}
                  // autoPageSize
                  autoHeight
                  type={type}
                  paginationMode="server"
                  // txtMessage={txtMessage}
                  entity={entity}
                />
              </div>
            </TableContainer>
          </CardContent>
        </Collapse>
      </Card>
    );
  }
  
  const TableContainer = styled.div`
    // display: flex;
    // height: 300px;
    // overflow-y: auto;
    // & * {
    //   ${thumbStack}
    // }
    .MuiDataGrid-root .MuiDataGrid-colCell,
    .MuiDataGrid-root .MuiDataGrid-cell {
      padding: 0px 8px;
    }
  `;

  const Option = styled.option`
    cursor: pointer;
    height: 40px;
    padding: 10px;

    &:hover{
      background: #CBDCEB;
    }
  `

  const IdentityInformationMap = {
    [EntityType.company]: CompanyInformation,
    [EntityType.person]: PersonInformation,
  };
  
  function IdentifiedEntityChips({ entity, setEntityValue, type, isSeller = false,badges}: { entity: EntitySearchModel, setEntityValue: any, type: String, isSeller: boolean,badges:any}) {
    let Details = IdentityInformationMap[entity.type];
    return (
      <>
        <Chip
          size="small"
          component={Link}
          target="_blank"
          href={`${type === EntityType.person ? `${DELI_ENV_BASE_URL}/person-management/edit/${entity.vtr_id}`: vtrUrl(entity.vtr_id, entity.type)}`}
          icon={<LaunchIcon />}
          label={`ID: ${entity.vtr_id}`}
          clickable
          color="primary"
        />
        {Details && (
          <>
            <Details entity={entity} setEntityValue={setEntityValue} isSeller={isSeller} badges={badges}/>
          </>
        )}
      </>
    );
  }
  
  const loadingSkeleton = <Skeleton animation="wave" width="30%" />;
 function CompanyInformation({
  entity,
  badges,
}: {
  entity: EntitySearchModel;
  badges: any;
}) {
  const { loading, data: company } = useCompanyLoader(entity.vtr_id);

  const badgesReady = Array.isArray(badges) && badges.length > 0;
  const companyReady = !loading && company;

  const reputationLoading =
    companyReady &&
    company?.reputation &&
    !badgesReady;

  let reputation: any;

  if (companyReady && badgesReady && company?.reputation) {
    reputation = computeReputationBadge( company.reputation ?? 0, badges);
  }

  if (!companyReady) return loadingSkeleton;

  return (
    <CompanyInfo
      type={company.company_types[0]?.name}
      hq={company.hqcountry}
      rep_badge={
        reputationLoading
          ? null
          : entity?.meta?.reputation_badge?.name || reputation?.name
      }
      showReputation={true}
      color="#0000008a"
      reputationLoading={reputationLoading}
    />
  );
}
  
  function PersonInformation({ entity, setEntityValue, isSeller = false}: { entity: EntitySearchModel, setEntityValue:any, isSeller: boolean}) {
    const { loading, data: person } = usePersonLoader(entity.vtr_id);
    return !loading && person ? <PersonInfo role={person.role_id} entity={entity} setEntityValue={setEntityValue} isSeller={isSeller}/> : loadingSkeleton;
  }

  type CurrentlyWorkingType = {
    value: String;
    name: String;
  }

  const NOT_SURE = 'not-sure';

  const currentlyWorkingLabel = (value: string) =>
    value === 'yes' ? 'Yes' : value === 'no' ? 'No' : 'Not Sure';

  const toCurrentlyWorkingUiValue = (raw) => {
    if (raw === undefined || raw === null || raw === '' || raw === NOT_SURE) {
      return NOT_SURE;
    }
    return raw;
  };

  const toCurrentlyWorkingPayload = (uiValue) =>
    uiValue === NOT_SURE || uiValue === '' || uiValue == null ? '' : uiValue;
  
  const PersonInfo = ({ role, entity, setEntityValue, isSeller = false}) => {
  //  const [designation, setDesignation] = useState("");
      const [designation, setDesignation] = useState( entity?.meta?.designation||entity?.designation || "");
  const {email_id = "",hubspot_id = ""} = entity?.meta || entity || {};
  const setDefaultValueAsYes = Boolean(email_id && hubspot_id);
const [currentlyWorking, setCurrentlyWorking] =
  useState<CurrentlyWorkingType>(() => {
    const raw = entity?.meta?.currently_working ?? entity?.currently_working;
    const hasExistingValue = raw !== undefined && raw !== null;
    const value = hasExistingValue
      ? toCurrentlyWorkingUiValue(raw)
      : (setDefaultValueAsYes ? 'yes' : NOT_SURE);

    return {
      value,
      name: currentlyWorkingLabel(value),
    };
  });

    const [marketsResponsible, setMarketsResponsible] = useState(
      entity?.meta?.markets_responsible || entity?.markets_responsible || []
    );
    const marketsRef = useRef(marketsResponsible);
    marketsRef.current = marketsResponsible;

    useEffect(()=>{
      const personEntity = { ...entity };
      if(personEntity){
        personEntity.designation = designation;
        personEntity.meta = {
          ...(personEntity.meta || {}),
          designation,
          markets_responsible: marketsRef.current,
        };
        personEntity.markets_responsible = marketsRef.current;
        setEntityValue(personEntity)

      }
    },[designation])
    
    useEffect(()=>{
     const cwValue = toCurrentlyWorkingPayload(currentlyWorking?.value);
     const personEntity = {
       ...entity,
       currently_working: cwValue,
       markets_responsible: marketsRef.current,
       meta: {
         ...(entity?.meta || {}),
         currently_working: cwValue,
         markets_responsible: marketsRef.current,
       },
     };
     setEntityValue(personEntity)
    },[currentlyWorking])

    useEffect(() => {
      const personEntity = {
        ...entity,
        markets_responsible: marketsResponsible,
        meta: {
          ...(entity?.meta || {}),
          markets_responsible: marketsResponsible,
        },
      };
      setEntityValue(personEntity);
    }, [marketsResponsible]);

  const [options, setOptions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  // Debounced function to fetch role options
  const debouncedSearchRoles = useCallback(
    debounce((searchTerm: string) => {
      setLoading(true);
      http_v3
        .get('/roles', {
          params: {
            role_name: searchTerm
          }
        })
        .pipe(
          map(res => res.data)
        )
        .subscribe({
          next: data => {
            let rolesArray = [];
            if (Array.isArray(data)) {
              rolesArray = data;
            } else if (data && Array.isArray(data.data)) {
              rolesArray = data.data;
            } else if (data && typeof data === 'object') {
              // If it's an object, try to extract array from common properties
              rolesArray = data.roles || data.items || data.results || [];
            }
            setOptions(rolesArray);
          },
          error: err => {
            console.error(err, 'Error fetching roles');
            setOptions([]); // Set empty array on error
          },
          complete: () => {
            setLoading(false);
          },
        });
    }, 300),
    []
  );

  useEffect(() => {
    // Initial load - fetch all roles
    debouncedSearchRoles('');
  }, [debouncedSearchRoles]);

    return (
      <Typography
        component="div"
        variant="body2"
        color="textSecondary"
        style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap', gap: '12px', width: '100%', paddingTop: '10px' }}>
        <LanguageIcon style={{ fontSize: '1em' }} /> {role}
        {
          <FormControl variant="outlined" style={{ width: 140, flex: '0 0 140px' }}>
            <InputLabel id="c2p-currently-working">CurrentlyWorking</InputLabel>
            <Select
              labelId="c2p-currently-working"
              label="Currently Working"
              style={{ height: 56 }}
              value={currentlyWorking?.value || NOT_SURE}
              onChange={e => {
                const value = toCurrentlyWorkingUiValue((e.target as { value: string }).value);
                setCurrentlyWorking({
                  value,
                  name: currentlyWorkingLabel(value),
                });
              }}>
              <Option value="yes">Yes</Option>
              <Option value="no">No</Option>
              <Option value={NOT_SURE}>Not Sure</Option>
            </Select>
          </FormControl>
        }
        {!isSeller && (
          <>
            <Autocomplete
              options={options || []}
              value={designation}
              onChange={(e, v) => {
                setDesignation(v);
              }}
              freeSolo
              onInputChange={(e, v) => {
                if (e?.type === 'change') {
                  setDesignation(v);
                  debouncedSearchRoles(v);
                }
              }}
              style={{ width: 400, flex: '0 0 400px' }}
              renderInput={props => (
                <TextField
                  label="Designation"
                  fullWidth
                  variant="outlined"
                  {...props}
                  InputProps={{
                    ...props.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loading ? (
                          <>
                            <CircularProgress color="inherit" size={20} />
                            {props.InputProps.endAdornment}
                          </>
                        ) : null}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </>
        )}
        <div style={{ flex: '1 1 auto', minWidth: 0 }}>
          <MarketsResponsibleField value={marketsResponsible} onChange={setMarketsResponsible} />
        </div>
      </Typography>
    );
    }
  

interface CompanyInfoProps {
  type: string;
  hq: string;
  rep_badge?: string;
  showReputation?: boolean;
  reputationLoading?: boolean;
  color?: string;
}

const CompanyInfo = ({
  type,
  hq,
  rep_badge,
  showReputation = false,
  reputationLoading = false,
  color,
}: CompanyInfoProps) => (
  <Typography
    variant="body2"
    color="textSecondary"
    style={{ display: 'flex', alignItems: 'center', gap: 4, color }}
  >
    <LanguageIcon style={{ fontSize: '1em' }} color="primary" />
    {hq},

    <CategoryIcon style={{ fontSize: '1em' }} color="secondary" />
    {type}.

    {showReputation && (
      reputationLoading ? (
        <Skeleton
          variant="rect"
          width={60}
          height={24}
          style={{ borderRadius: 12, marginLeft: 4 }}
        />
      ) : (
        rep_badge && (
          <Chip
            label={rep_badge}
            size="small"
            style={{
              margin: 1,
              backgroundColor: getBadgeColor(rep_badge),
              color: '#fff',
              fontWeight: 500,
            }}
          />
        )
      )
    )}
  </Typography>
);

  
  type EntitySearchResultProps = Omit<DataGridProps, 'columns'> & {
    type: EntityType | `${EntityType}` | string;
    entity: any;
  };

  function EntitySearchResult({ type, ...props }: EntitySearchResultProps) {
    return (
      <DataGrid
        density="compact"
        key={`${type}-${props.rowCount}`}
        columns={contentToColumns(props?.entity)[type || EntityType.company]}
        {...props}
        components={{ NoRowsOverlay: customNoRowsOverlay }}
        componentsProps={{ noRowsOverlay: { txtMessage: type } }}
      />
    );
  }
  const customNoRowsOverlay = (props) => {
      let redirectURL = ''
      if(props?.txtMessage == 'PERSON'){
        redirectURL = '/person-management/new';
      }
      else{
        redirectURL = '/company/new';
      }
      return (
        <Grid
          container
          justify="center"
          alignContent="center"
          style={{ position: 'absolute', top: '20%', height: '100%', zIndex: 999 }}>
          <Grid item>
            <span>No Records Found. <Link1 to={redirectURL} target="_blank">Create New</Link1></span>
          </Grid>
        </Grid>
      
    );
  };
  const StyledBadge = withStyles(theme => ({
    badge: {
      right: 5,
      top: 10,
      border: `2px solid ${theme.palette.background.paper}`,
      padding: '0 4px',
    },
  }))(Badge);
  